import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { ActionRow } from '../ActionRow/ActionRow';
import { Button } from '../Button/Button';

export type ConfirmationDialogProps = {
  open: boolean;
  handleCancel: () => void;
  handleConfirm: () => void;
  handleDismiss?: () => void;
  title: string;
  message?: string;
  disableBackdropClose?: boolean;
  slotProps?: {
    cancelButton?: Omit<React.ComponentProps<typeof Button>, 'onClick'>;
    confirmButton?: Omit<React.ComponentProps<typeof Button>, 'onClick'>;
    dismissButton?: Omit<React.ComponentProps<typeof Button>, 'onClick'>;
  };
  enableDismissButton?: boolean;
};

export const ConfirmationDialog = ({
  open,
  handleCancel,
  handleConfirm,
  title,
  message,
  disableBackdropClose = false,
  slotProps,
  handleDismiss,
  enableDismissButton = false,
}: ConfirmationDialogProps) => {
  const { children: cancelChildren, ...cancelButtonProps } = slotProps?.cancelButton || {
    children: 'Cancel',
    variant: 'secondary',
  };
  const { children: confirmChildren, ...confirmButtonProps } = slotProps?.confirmButton || {
    children: 'Confirm',
    variant: 'primary',
  };
  const { children: dismissChildren, ...dismissButtonProps } = slotProps?.dismissButton || {
    children: 'Cancel',
    variant: 'text',
  };
  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (disableBackdropClose && reason) {
          return;
        }
        handleCancel();
      }}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      data-testid="dialog"
    >
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      {message ? (
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">{message}</DialogContentText>
        </DialogContent>
      ) : null}
      <DialogActions
        sx={{
          flexDirection: 'column',
        }}
      >
        <ActionRow>
          <Button fullWidth onClick={handleCancel} {...cancelButtonProps}>
            {cancelChildren}
          </Button>
          <Button fullWidth onClick={handleConfirm} autoFocus {...confirmButtonProps}>
            {confirmChildren}
          </Button>
        </ActionRow>
        {enableDismissButton ? (
          <Button fullWidth onClick={handleDismiss} {...dismissButtonProps}>
            {dismissChildren}
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};
